export default __webpack_public_path__ + "static/media/ic_add.c63781c6.svg";